import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const PriceProfile = React.memo((props) => {
  const { priceProfileData, isFetched, isLoading } = props;
  const { colors } = useTheme();
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Price profile </H9TitleSmall>
        <StyledIconButton colors={colors}>
          <KeyboardArrowRightIcon
            fontSize="medium"
          />
        </StyledIconButton>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: "#EEEDF7",
            borderRadius: "1.5rem",
          }}
        >
          {isFetched &&
            Object.keys(priceProfileData).length > 0 && (
              <>
                <ListItem>
                  <ListItemText>
                    {priceProfileData?.configName}
                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText
                    secondary={priceProfileData?.ISO}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    secondary={
                      priceProfileData?.TunePreference
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    secondary={priceProfileData?.hashrate}
                  />
                </ListItem>
              </>
            )}

          {isFetched &&
            Object.keys(priceProfileData).length === 0 && (
              <>
                <ListItem>
                  <ListItemText secondary="No price profile data available" />
                </ListItem>
              </>
            )}
        </List>
      </>
    </Box>
  );
});
